/** Inter-only typography for /analytics surfaces (charts, SVG labels, IDs). */
export const ANALYTICS_FONT_FAMILY = '"Inter", sans-serif';

export {
  ANALYTICS_GREEN,
  ANALYTICS_RED,
  analyticsGreenAlpha,
  analyticsRedAlpha,
} from './analyticsColors';

export const ANALYTICS_CHART_TICK = {
  fontSize: 10,
  fill: 'rgba(0,0,0,0.35)',
  fontFamily: ANALYTICS_FONT_FAMILY,
};

export const ANALYTICS_TABULAR_SX = {
  fontFamily: ANALYTICS_FONT_FAMILY,
  fontVariantNumeric: 'tabular-nums',
};

/**
 * Large KPI numerals on /analytics cards. Avoid tabular-nums here — at
 * 2.5–3rem Inter can clip glyph counters in WebKit when composited under
 * backdrop-filter. Slightly taller line-height prevents tight box clipping.
 */
export const ANALYTICS_HEADLINE_NUMBER_SX = {
  fontFamily: ANALYTICS_FONT_FAMILY,
  fontSize: { xs: '2.5rem', md: '3rem' },
  fontWeight: 600,
  color: 'rgba(0,0,0,0.88)',
  lineHeight: 1.2,
  letterSpacing: '-0.02em',
  WebkitFontSmoothing: 'antialiased',
  MozOsxFontSmoothing: 'grayscale',
};
